// extracted by mini-css-extract-plugin
export default {"addToCart":"AddedToCartBig_addToCart__75Ql4","add":"AddedToCartBig_add__AOo8V"};